import React from 'react';
import { Tooltip, Typography } from '@mui/material';

export const NotProvided: React.FC<{ field: string }> = ({ field }) => (
  <Tooltip title={`No ${field} available for this candidate`} placement="top">
    <Typography variant="body2" color="text.lightGrey">
      —
    </Typography>
  </Tooltip>
);
